import { type LoaderFunction, Outlet, redirect, useLoaderData } from "react-router-dom";

import { get } from "@/api";
import { getGetUserInfoQueryOptions } from "@/api/orval/user/user";
import type { Models } from "@/api/types";
import { queryClient } from "@/pages/Root";
import { identifyFlagVisitor } from "@/services/Flags";
import Services from "@/services/Services";
import { waitObj } from "@/toolbox/Promise";
import { isNativeMobileApp } from "@/utils/platform.helpers";

import { getPlatformCurrent } from "api/methods";

export const PublicReferralRewardLayout = () => {
  const { platform } = useLoaderData() as {
    platform: Models<"PlatformModel">;
  };

  return (
    <div className="PublicReferralRewardLayout mx-auto flex min-h-screen w-full max-w-[390px] flex-col">
      <Outlet />
    </div>
  );
};

export const PublicReferralRewardLayoutLoader: LoaderFunction = async ({ request }: any) => {
  // The catch sits outside the query so a failed fetch resolves to null here without being cached
  // as data under the key every other `getPlatformCurrent` consumer reads.
  const platform = await queryClient.fetchQuery(getPlatformCurrent.keyed()).catch(() => null);

  const token = await Services.auth.loadToken();
  const user = token
    ? await queryClient.fetchQuery(getGetUserInfoQueryOptions()).catch(() => null)
    : null;

  // Ensure we have a flag context for targeting rules; a signed-in patient keeps their own
  identifyFlagVisitor(user, platform);

  // If the platform is not active, redirect to the deactivated page
  if (platform?.active === false) {
    if ((isNativeMobileApp() && !request.url.includes("/signin")) || !isNativeMobileApp()) {
      return redirect("/deactivated");
    }

    return null;
  }

  return waitObj({
    platform,
  });
};
